export default {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    instructionCard: {
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "20px",
        backgroundColor: "#f9f9f9",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        width: "70%",
    },
    strong: {
        display: "block",
        marginBottom: "10px",
        fontSize: "18px",
    },
    li: {
        marginBottom: "10px",
        display: "flex",
        alignItems: "center",
    },
    ul: {
        listStyleType: "none",
        padding: "0",
    },
    bullet: {
        marginRight: "10px",
        fontSize: "20px",
    },
    gridRecordsMargin: {
        marginLeft: '150px',
    }
}